// react components
import React, {
    useEffect,
    useState,
} from 'react'
import {
    useSelector,
} from 'react-redux'

// data
import {
    contentTypeModelTypeSite,
    defaultReduxState,
} from 'data'

// pages
import {
    Button825,
    FormContentBlock825,
} from 'pages'

// serializers
import {
    ContentTypeFormTypes,
    ContentTypeSettingsCustomTypes,
    ContentTypeSettingsTypes,
} from 'serializers/site'

// services
import {
    getReduxTextIdSite,
} from 'services'

// props
type FormContent825Props = {
    contentType: contentTypeModelTypeSite
    contentTypeSettings: ContentTypeSettingsTypes
    contentTypeSettingsCustom: ContentTypeSettingsCustomTypes
    formState: ContentTypeFormTypes
    getMetaIsLoading?: boolean
    handleInputChange: (event: any, newFormState: ContentTypeFormTypes) => void
    noTabs?: boolean
    object: any
    onKeyPress: any
    subContentTypeForced?: { id: number, name: string }
    verticalStyle?: boolean
}

// main
export const FormContent825: React.FC<FormContent825Props> = React.memo(({
    contentType,
    contentTypeSettings,
    contentTypeSettingsCustom,
    formState,
    getMetaIsLoading,
    handleInputChange,
    noTabs,
    object,
    onKeyPress,
    subContentTypeForced,
    verticalStyle,
}) => {

    const reduxAuth = useSelector((state: defaultReduxState) => state.reduxAuth)
    const reduxText = useSelector((state: defaultReduxState) => state.reduxText.data)

    useEffect(() => {
        setTab(panelsOrdered[0].id)
    }, [
        object.sub_content_type,
        subContentTypeForced,
    ])

    const panels = (formState.structure?.panels.length > 0 && formState.structure?.panels) || contentTypeSettings.form.structure?.panels
    const panelsSubContentType: any = []
    if (object.sub_content_type && !contentType.startsWith('setup_')) {
        if (contentTypeSettingsCustom?.form?.panelsSubContentType?.[subContentTypeForced?.id || object.sub_content_type.id!]) {
            panelsSubContentType.push(...contentTypeSettingsCustom?.form?.panelsSubContentType?.[subContentTypeForced?.id || object.sub_content_type.id!]?.panels || [])
        } else {
            panelsSubContentType.push(...contentTypeSettings.form?.panelsSubContentType?.[subContentTypeForced?.id || object.sub_content_type.id!]?.panels || [])
        }
        // @ts-ignore
        panelsSubContentType.push(panels?.find(obj => obj.title === 'reduxText[9340]'))
        // @ts-ignore
        panelsSubContentType.push(panels?.find(obj => obj.title === 'reduxText[9736]'))
    }
    const panelsOrdered = panelsSubContentType.length > 0 ? panelsSubContentType : panels

    const [tab, setTab] = useState<(number)>(panelsOrdered[0].id)

    const tabData = panelsOrdered.find((obj: any) => obj.id === tab)

    return (
        <div className='form-component-825'>
            {!noTabs && (
                <div className='fc-tabs'>
                    <div className='fc-buttons'>
                        {panelsOrdered.map((val: any) => {
                            if (val.panelOptions?.hideIfNotStaff) return null
                            if (val.panelOptions?.hideIfNotSuperuser) return null
                            if (['reduxText[9340]', 'reduxText[9736]'].includes(val.title)) return null
                            return (
                                <Button825
                                    key={val.id}
                                    className={(tab === val.id) ? 'fc-active' : ''}
                                    color={getReduxTextIdSite(val.title!, reduxText) ? undefined : 'danger'}
                                    edit={false}
                                    fill='clear'
                                    justifyText='flex-start'
                                    onClick={() => setTab(val.id)}
                                    size='small'
                                    text={getReduxTextIdSite(val.title!, reduxText) || 'Error: Missing tab title'}
                                />
                            )
                        })}
                    </div>
                </div>
            )}
            <FormContentBlock825
                contentType={contentType}
                contentTypeSettings={contentTypeSettings}
                contentTypeSettingsCustom={contentTypeSettingsCustom}
                formState={formState}
                getMetaIsLoading={getMetaIsLoading}
                handleInputChange={handleInputChange}
                object={object}
                onKeyPress={onKeyPress}
                tab={tab}
                tabData={tabData}
                subContentTypeForced={subContentTypeForced}
                verticalStyle={verticalStyle}
            />
        </div>
    )
})
